/*
 * * * * * * * * * *
 *
 *   MODULE
 *
 * * * * * * * * * *
 */

import Vector from '@bbx/vector~master/core/env/browser/vue/Vector.vue'
import Responsive from '@bbx/responsive~master/core/env/browser/vue/Responsive.vue'

/*
 * * * * * * * * * *
 *
 *   RELATIVE
 *
 * * * * * * * * * *
 */

import Core from "../vue/Core.vue"
import Title from "../vue/title/Title.vue"
import Grid from "../vue/grid/Grid.vue"
import GridH from "../vue/grid/GridH.vue"
import Animation from "../vue/animation/Animation.vue"
import Paragraph from "../vue/paragraph/Paragraph.vue"
import Spacer from "../vue/spacer/Spacer.vue"
import Button from "../vue/button/Button.vue"
import Home from '../vue/home/Home.vue'
import GoogleRecaptcha from '../vue/google/GoogleRecaptcha.vue'
import Contact from '../vue/contact/Contact.vue'
import Formation from '../vue/formation/Formation.vue'
import ConseilRecrutement from '../vue/conseil/ConseilRecrutement.vue'
import ConseilExtern from '../vue/conseil/ConseilExtern.vue'
import ConseilAccomp from '../vue/conseil/ConseilAccomp.vue'
import EvolutionAccomp from '../vue/evolution/EvolutionAccomp.vue'
import EvolutionBilan from '../vue/evolution/EvolutionBilan.vue'
import EvolutionValidation from '../vue/evolution/EvolutionValidation.vue'
import ConnaitreJobstream from '../vue/connaitre/ConnaitreJobsteam.vue'
import ConnaitreEquipe from '../vue/connaitre/ConnaitreEquipe.vue'
import ConnaitreRejoindre from '../vue/connaitre/ConnaitreRejoindre.vue'
import ConnaitreEngagement from '../vue/connaitre/ConnaitreEngagement.vue'
import ConnaitrePartenaires from '../vue/connaitre/ConnaitrePartenaires.vue'
import Politique from '../vue/cookie/Politique.vue'
import CGV from '../vue/legal/CGV.vue'
import MentionsLegales from '../vue/legal/MentionsLegales.vue'
import ConnaitreConfiance from '../vue/connaitre/ConnaitreConfiance.vue'
import Cookie from '../vue/cookie/Cookie.vue'
import Menu from '../vue/menu/Menu.vue'
import Footer from '../vue/footer/Footer.vue'

export const COMPONENT = {

    /* MODULE */

    Responsive,
    Vector,

    /* RELATIVE */

    Core,
    Grid,
    GridH,
    Animation,
    Title,
    Paragraph,
    Spacer,
    Button,
    Home,
    GoogleRecaptcha,
    Contact,
    Formation,
    ConseilRecrutement,
    ConseilExtern,
    ConseilAccomp,
    EvolutionAccomp,
    EvolutionBilan,
    EvolutionValidation,
    ConnaitreJobstream,
    ConnaitreEquipe,
    ConnaitreRejoindre,
    ConnaitreEngagement,
    ConnaitrePartenaires,
    Politique,
    CGV,
    MentionsLegales,
    ConnaitreConfiance,
    Cookie,
    Menu,
    Footer,
}